/**
 * The area of a truck an item sits in: the top of its section path
 * ("Drivers side › Locker 4 › Tray 3" → "Drivers side"). People split a
 * check by area, so the wizard can stay inside one.
 */
export function areaOf(item: { sectionName?: string | null }): string {
  return (item.sectionName ?? 'General').split(' › ')[0] || 'General';
}

/** Where the wizard for an item lives, keeping the area it was started from. */
export function itemPath(runId: string, itemId: string, area?: string | null): string {
  return `/checks/${runId}/items/${itemId}${area ? `?area=${encodeURIComponent(area)}` : ''}`;
}
